
import { defineComponent, ref } from 'vue'
import Site from './site/Site.vue'
// import Bank from './bank/Banks.vue'
import CheckStatus from './check_status/CheckStatus.vue'
import PaymentPortalStatus from './payment_portal_status/PaymentPortalStatus.vue'
import PaymentStatusEvent from './payment_status_event/PaymentStatusEvent.vue'
// import PaymentStatusUpdater from './payment_status_updater/PaymentStatusUpdater.vue'
import PaymentStatusMapping from './payment_status_mapping/PaymentStatusMapping.vue'
import IbpsStatus from './ibps_status/IbpsStatus.vue'
import PaymentMethod from './payment_method/PaymentMethod.vue'
import SmsTemplate from './sms_template/SmsTemplate.vue'
import EmailTemplate from './email_template/EmailTemplate.vue'
// import NotificationGroup from './notification_group/NotificationGroup.vue'
// import SmsRecipient from './sms_recipient/SmsRecipient.vue'
// import EmailRecipient from './email_recipient/EmailRecipient.vue'
import canView from '../../../classes/view_checker'

export default defineComponent({
  components: {
    Site,
    // Bank,
    CheckStatus,
    PaymentPortalStatus,
    PaymentStatusEvent,
    // PaymentStatusUpdater,
    PaymentStatusMapping,
    IbpsStatus,
    PaymentMethod,
    SmsTemplate,
    EmailTemplate,
    // NotificationGroup,
    // SmsRecipient,
    // EmailRecipient
  },
  setup(){
    const name = ref('System Settings');

    return {
      name,
      canView
    }
  }
 
});
